// @flow

import * as React from "react";
import {
  ComposedChart,
  XAxis,
  YAxis,
  Bar,
  ErrorBar,
  Label,
  Line,
  Legend
} from "recharts";

import type { CalibrationStats } from "../../utils/calibration";

import "./CalibrationChart.css";

type CalibrationChartProps = {
  title?: string,
  data: CalibrationStats
};

const CalibrationChart = (props: CalibrationChartProps) => (
  <div className="CalibrationChart">
    {props.title && (
      <span className="CalibrationChart-Title">{props.title}</span>
    )}
    <ComposedChart
      width={300}
      height={300}
      margin={{ top: 5, right: 5, bottom: 30, left: 5 }}
      data={props.data}
    >
      <XAxis dataKey="confidence" unit="%">
        <Label value="Your probability" offset={5} position="bottom" />
      </XAxis>
      <YAxis domain={[0, 1]} unit="%">
        <Label
          angle={-90}
          value="Actual frequency"
          position="insideLeft"
          style={{ textAnchor: "middle" }}
        />
      </YAxis>
      <Bar
        legendType="none"
        type="monotone"
        dataKey="mean"
        barSize={30}
        fill="#c5e5ff"
        stroke="#295f90"
      >
        <ErrorBar
          dataKey="stdev"
          width={4}
          strokeWidth={1}
          stroke="#295f90"
          direction="y"
        />
      </Bar>
      <Line
        name="Perfect calibration"
        type="monotone"
        dataKey="confidence"
        stroke="#1dd21d"
        strokeWidth={2}
      />
      <Legend verticalAlign="top" height={36} />
    </ComposedChart>
  </div>
);

export default CalibrationChart;



// WEBPACK FOOTER //
// ./src/components/CalibrationChart/CalibrationChart.js